import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Privacy Policy for Master Sudoku Challenge</h1>
      <p><strong>Effective Date:</strong> 09/17/2024</p>

      <p>
        This Privacy Policy explains how Ygalaad ("we", "us", "our") collects, uses, and discloses information when you use our mobile application, Master Sudoku Challenge (the "App").
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We may collect the following types of information when you use the App:
        <ul>
          <li><strong>Personal Information:</strong> We do not collect personal information such as your name, email address, or phone number unless you voluntarily provide it (e.g., via customer support requests).</li>
          <li><strong>Usage Data:</strong> We collect anonymous usage data, including in-game statistics and interactions with the App, to help us improve the user experience.</li>
          <li><strong>Device Information:</strong> We may collect device-specific information, such as your IP address, device ID, operating system, and app version.</li>
        </ul>
      </p>

      <h2>2. How We Use Your Information</h2>
      <p>
        We use the information we collect for the following purposes:
        <ul>
          <li>To improve and personalize your experience with the App.</li>
          <li>To analyze usage and trends to better understand how our App is used.</li>
          <li>To ensure the proper functionality and security of the App.</li>
        </ul>
      </p>

      <h2>3. Third-Party Services</h2>
      <p>
        We don't use third-party services.
      </p>

      <h2>4. Data Retention</h2>
      <p>We retain data only for as long as necessary to provide you with the App's services and improve the App. After this period, we will securely delete or anonymize your data.</p>

      <h2>5. Data Security</h2>
      <p>
        We take reasonable steps to protect the information we collect from loss, theft, misuse, and unauthorized access. However, no method of transmission over the internet or method of electronic storage is completely secure, and we cannot guarantee absolute security.
      </p>

      <h2>6. Children's Privacy</h2>
      <p>
        Our App is not intended for children under the age of 13, and we do not knowingly collect personal information from children. If you believe we have inadvertently collected such information, please contact us, and we will delete it.
      </p>

      <h2>7. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. When we do, we will revise the effective date at the top of this page. We encourage you to review this policy periodically to stay informed about how we are protecting your information.
      </p>

      <h2>8. Your Rights</h2>
      <p>
        Depending on your location, you may have the right to:
        <ul>
          <li>Request access to your data.</li>
          <li>Request correction or deletion of your data.</li>
          <li>Opt-out of data collection by uninstalling the App.</li>
        </ul>
      </p>

      <h2>9. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy or the App, please contact us at:
        <ul>
          <li><strong>Email:</strong> contact@ygalaad.com</li>
          <li><strong>Address:</strong> Ygalaad, 230 Route Des Dollines 06560 VALBONNE</li>
        </ul>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
